var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPadlock = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.5 9V7a3.5 3.5 0 1 0-7 0v2zM12 2a5 5 0 0 0-5 5v2H4v13h16V9h-3V7a5 5 0 0 0-5-5m-6.5 8.5v10h13v-10zm8 4.25a1.5 1.5 0 0 1-.75 1.3v1.7h-1.5v-1.7a1.5 1.5 0 1 1 2.25-1.3",
    clipRule: "evenodd"
  })));
};
export default SvgPadlock;